import { CampaignPlace } from '../../typings/campaignPlace';

export const REVERT_CAMPAIGN_PLACE_EDITOR = 'REVERT_CAMPAIGN_PLACE_EDITOR';
export type REVERT_CAMPAIGN_PLACE_EDITOR = typeof REVERT_CAMPAIGN_PLACE_EDITOR;

export interface RevertCampaignPlaceEditor {
    type: REVERT_CAMPAIGN_PLACE_EDITOR;
    editorId: string;
    place: CampaignPlace;
}

export function revertCampaignPlaceEditorAction(editorId: string, place: CampaignPlace): RevertCampaignPlaceEditor {
    return {
        type: REVERT_CAMPAIGN_PLACE_EDITOR,
        editorId,
        place
    };
}
